<template>
  <el-table-column
    prop="outstanding"
    sortable="custom"
    label="Kintlevőség"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.outstanding | currency(scope.row.currency_code) }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'outstanding',
};
</script>
